import type { IUserInfo } from "@/account/account-models";
import { defined } from "@/utils/variable-evaluation";

export function avatarFromUser(user: IUserInfo) {
  if (defined(user) && defined(user.avatar)) {
    return user.avatar;
  }
  return null;
}

export enum EAvatarType {
  Header = "Header",
  Boost = "Boost",
  Login = "Login",
  CompleteProfile = "CompleteProfile",
  ChatsItem = "ChatsItem",
  AccountMain = "AccountMain",
  DesktopDiscover = "DesktopDiscover",
  DesktopStickyDiscover = "DesktopStickyDiscover",
  MessengerAllRead = "MessengerAllRead",
  GetAccess = "GetAccess",
  SubscribePopup = "SubscribePopup",
  PaymentPopup = "PaymentPopup",
  TipSuccessPopup = "TipSuccessPopup",
  HeaderDesktop = "HeaderDesktop",
  HeaderMobileIcon = "HeaderMobileIcon",
  VIPAnnouncement = "VIPAnnouncement",
  Promo = "Promo",
  MyPurchase = "MyPurchase",
  UnblockUser = "UnblockUser",
}
